import { SkinOutlined } from '@ant-design/icons';
import { useModel } from '@umijs/max';
import { Drawer, Tooltip } from 'antd';
import React, { useState } from 'react';
import { ThemeStudio, isMallEnabled, isVizUiTheme } from '@yunnao/ui-themes';

/** 顶栏：主题配置入口（需 enableMall: true） */
export const ThemeConfigButton: React.FC = () => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const [open, setOpen] = useState(false);

  if (!isMallEnabled()) return null;

  return (
    <>
      <Tooltip title="主题配置">
        <span
          role="button"
          tabIndex={0}
          onClick={() => setOpen(true)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') setOpen(true);
          }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 32,
            height: 32,
            cursor: 'pointer',
            color: 'inherit',
            fontSize: 16,
          }}
        >
          <SkinOutlined />
        </span>
      </Tooltip>
      <Drawer
        title="主题配置"
        open={open}
        onClose={() => setOpen(false)}
        width={Math.min(
          760,
          typeof window !== 'undefined' ? window.innerWidth - 24 : 760,
        )}
        styles={{ body: { paddingTop: 12 } }}
        destroyOnClose={false}
      >
        <ThemeStudio
          compact
          value={initialState?.uiThemeId}
          onChange={(recipe, settings) => {
            const id =
              recipe.legacyThemeId || recipe.slots.palette || recipe.id;
            setInitialState((state) => ({
              ...state,
              uiThemeId: id,
              settings: { ...state?.settings, ...settings },
              siderCollapsed: isVizUiTheme(id),
            }));
          }}
        />
      </Drawer>
    </>
  );
};

export default ThemeConfigButton;
